import React from 'react';
import styled, { css } from 'styled-components';
import { MdCheck } from 'react-icons/md';

const Wrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const OriginalCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  vertical-align: middle;
`;

const CustomCheckbox = styled.div`
  display: inline-block;
  border-radius: 4px;
  border: solid 2px #aeaeae;
  ${({ checked, size }) => {
    return css`
      background: ${checked ? '#0b8793' : 'white'};
      width: ${size && size > 0 ? `${size}px` : '18px'};
      height: ${size && size > 0 ? `${size}px` : '18px'};
    `;
  }}
`;

export default function Checkbox({ checked, ...props }) {
  const size = props.size || 18;
  return (
    <Wrapper>
      <OriginalCheckbox checked={checked} {...props} />
      <CustomCheckbox checked={checked}>
        {checked && <MdCheck color="white" size={size+2} />}
      </CustomCheckbox>
    </Wrapper>
  );
}
